"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainError = void 0;
const handled_error_1 = require("./handled.error");
class DomainError extends handled_error_1.HandledError {
    constructor(message, code) {
        super(message);
        this.message = message;
        this.code = code;
    }
}
exports.DomainError = DomainError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG9tYWluLmVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2RvbWFpbi5lcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtREFBOEM7QUFFOUMsTUFBYSxXQUFZLFNBQVEsNEJBQVk7SUFDM0MsWUFBcUIsT0FBZSxFQUFXLElBQWE7UUFDMUQsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFBO1FBREssWUFBTyxHQUFQLE9BQU8sQ0FBUTtRQUFXLFNBQUksR0FBSixJQUFJLENBQVM7SUFFNUQsQ0FBQztDQUNGO0FBSkQsa0NBSUMifQ==